export default __webpack_public_path__ + "static/media/green-tick.13af4be4.svg";